import { STATUS, logger } from './utils';

interface ResponseProps {
    /**
     * Response request
     */
    response?: any;
    /**
     * Actions api
     */
    actions?: any;
}

const responseHandler = ({ response = {}, actions = {} }: ResponseProps) => {
    const { request = {}, data, status } = response;
    logger({
        origin: 'API - RESPONSE',
        endpoint: request.responseURL,
        response: JSON.stringify(data),
        status: status || request.status,
    });
    return response;
};

interface ErrorProps {
    /**
     * Error request
     */
    error?: any;
    /**
     * Actions api
     */
    actions?: any;
    /**
     * Set auth method to refresh token
     */
    setAuthorization?(token);
}

const errorHandler = ({ error = {}, actions = {}, setAuthorization }: ErrorProps) => {
    const normalizeError = typeof error === 'object' ? error : {};
    const { response = {}, request = {}, config } = normalizeError;
    const { status } = response;
    const { responseURL: endpoint } = request;

    logger({ origin: `API - ERROR ${status}`, endpoint, status });

    if (error?.response?.status === STATUS.UNAUTHORIZED && config?.retry !== false) {
        // Manage UNAUTHORIZED request
    }

    return error;
};

export default {
    responseHandler,
    errorHandler,
};
